const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    aguardando: false,
    lista: [], 
    listaUnidade: [],
    listaTipo: [{ id: 'custo', valor: 'Custo' }, { id: 'receita', valor: 'Receita' }]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ANALITICA_IMPORTACAO_MES_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'ANALITICA_IMPORTACAO_MES_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'ANALITICA_IMPORTACAO_MES_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'ANALITICA_IMPORTACAO_MES_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
            };
                      
        default:
            return state;
    }
}
